export default "__VITE_ASSET__Cis7H149__"